<template>
  <v-progress-linear
    v-if="activeAccountFlow.isLoading || !isSpaygEnabled"
    color="border"
    indeterminate
    data-testid="linear-progress-bar"
  />
  <div v-else-if="activeAccountFlow.accountStatus !== AccountStatuses.ACTIVE">
    <SoAlert
      :title="`This account is ${activeAccountFlow.accountStatusFormatted}`"
      type="warning"
      class="ma-4"
      data-testid="spayg-no-active-account"
    >
      You cannot change to <b>Smart Pay As You Go</b>.
      <template
        v-if="
          activeAccountFlow.accountStatus !== AccountStatuses.NOT_ON_SUPPLY &&
          activeAccountFlow.activeAccountNumber
        "
      >
        To change to <b>Smart Pay As You Go</b> on this property, go to account
        number
        <router-link
          :to="`/customer/${activeAccountFlow.activeAccountNumber}/spayg`"
          class="text-primary text-decoration-none"
          data-testid="spayg-go-to-active-account"
          >{{ activeAccountFlow.activeAccountNumber }}</router-link
        >
      </template>
    </SoAlert>
  </div>
  <div v-else>
    <SoFlow
      :workflow-id="FlowType.Spayg"
      :account-number="activeAccountFlow.current.accountNumber"
      title="Smart Pay As You Go"
      start-step="start"
      data-testid="spayg-flow"
      @closed="activeAccountFlow.closeFlow()"
    />
  </div>
  <SoFlowExit
    v-model="activeAccountFlow.isExitWorkflowModalOpen"
    @on-workflow-exit="activeAccountFlow.closeFlowConfirm"
  />
</template>

<script lang="ts">
  import { AccountStatuses } from "@/models/account/account.types"
  import { FlowType } from "@/flows/useCases"
  import SoFlow from "@/flows/SoFlow.vue"
  import SoFlowExit from "@/flows/SoFlowExit.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { useActiveAccountFlow } from "@/composables/useActiveAccountFlow"
  import { FeaturesService } from "@/services/admin/FeaturesService"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      SoFlow,
      SoFlowExit,
      SoAlert,
    },

    data() {
      return {
        AccountStatuses,
        FlowType,
        activeAccountFlow: useActiveAccountFlow(),
      }
    },

    computed: {
      isSpaygEnabled() {
        return FeaturesService.isFeatureActive("SMART_PAY_AS_YOU_GO")
      },
    },
  })
</script>

<style scoped>
  :deep(header + div.v-row) {
    margin: 0;
  }
  :deep(header + div.v-row > .v-col) {
    padding: 0;
  }
</style>
